import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Base } from "../shared/model/core/base.model";
import { ConsultaList } from "../shared/model/core/ConsultaList.model";
import { Aplicacion } from "../shared/model/fise/aplicacion.model";
import { ConfiguracionBean } from "../shared/model/fise/configuracionbean.model";
import { Servidor } from "../shared/model/fise/servidor.model";
import { UsuarioFise } from "../shared/model/security/userbean.model";
import { Usuario } from "../shared/model/security/usuario.model";
import { UrlConstantes } from "../utilerias/constantes/urlconstantes";

@Injectable({
    providedIn: 'root'
})
export class FiseService{
   
    constructor(private httpClient: HttpClient){}

    //ServerApplicationAdminService

    encontrarServidores(reqServidor: ConsultaList<Servidor>) {
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.ServidorGestionConsulta, reqServidor);
    }

    encontrarUsuarioPorServidor(reqUsuarioBean: number) {
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.FINDUSERBYSERVER, reqUsuarioBean);
    }
    
    encontrarAplicacionPorServidor(reqAplicacion: ConsultaList<Aplicacion>){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.FINDAPPLICATIONBYSERVER, reqAplicacion);
    }

    encontrarUsuarioPorAplicacion(reqUsuarioBean: ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.FINDUSERBYAPPLICATION, reqUsuarioBean);
    }

    BuscarAplicacionAdmin(reqAplicacion: ConsultaList<Aplicacion>){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.BUSCARAPLICACION, reqAplicacion);
    }

    BuscarUsuarioXAplicacionAdmin(reqUsuarioBean: ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.BUSCARAPLICACION, reqUsuarioBean);
    }

    BuscarUsuarioXServidorAdmin(reqUsuarioBean: ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.BUSCARUSUARIOPORSERVIDOR, reqUsuarioBean);
    }

    BuscarServidorPorFiltro(reqServdidor:Servidor){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.SEARCHSERVERBYFILTERS, reqServdidor);
    }
    
    //ServerApplicationService
    EncontrarServidor(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.FINDSERVER, reqServidor);
    }

    EncontrarUsuarioPorServidor(reqUsuarioBean: ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.FINDUSERBYSERVER, reqUsuarioBean);
    }

    EncontrarAplicacionPorServidor(reqAplicacion: ConsultaList<Aplicacion>){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.FINDAPPLICATIONBYSERVER, reqAplicacion);
    }

    EncontrarUsuarioPorAplicacion(reqUsuarioBean: number){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.FINDUSERBYAPPLICATION, reqUsuarioBean);
    }

    BuscarAplicacion(reqAplicacion: Aplicacion){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.BUSCARAPLICACION, reqAplicacion);
    }

    BuscarUsuarioPorAplicacion(reqUsuarioBean: ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.BUSCARUSUARIOXAPLICACION, reqUsuarioBean);
    }

    BuscarUsuarioPorServdidor(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.BUSCARUSUARIOPORSERVIDOR, reqUsuarioBean);
    }

    BuscarServidorXFiltros(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.BUSCARUSUARIOPORSERVIDOR, reqServidor);
    }
    FINDSERVERAdmin(reqServdidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.FINDSERVERAdmin, reqServdidor);
    }
    ConsultaNumUsuarios(reqUsuario: Usuario){
        return this.httpClient.post<Base>(UrlConstantes.CONSULTA_NUM_USUARIOS, reqUsuario);
    }
    ConsultaNumAplicaciones(reqAplicacion: Aplicacion){
        return this.httpClient.post<Base>(UrlConstantes.CONSULTA_NUM_APLICACIONES, reqAplicacion);
    }

    ConsultaNumAplicacionesCOS(reqAplicacion: Aplicacion){
        return this.httpClient.post<Base>(UrlConstantes.CONSULTA_NUM_APLICACIONES_COS, reqAplicacion);
    }
    //ServerService

    ObtenerdatosServidoryUsuario(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.GetServerAndUserData, reqServidor);
    }

    ServidorGuardaroActulizar(reqServidor: Servidor){
        return this.httpClient.post<Base>(UrlConstantes.ServerSaveOrUpdate, reqServidor);
    }

    ObtenerDatosdeUsuario(reqServidor: number){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GETUSERDATA, reqServidor);
    }
    ObtenerServer(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.GET_SERVER, reqServidor);
    }


    //ServidorGestionService
    
    ServidorGestionConsulta(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.ServidorGestionConsulta, reqServidor);
    }

    BorrarServidor(reqServidor: Servidor){
        return this.httpClient.post<Base>(UrlConstantes.BorrarServidor, reqServidor);
    }

    consultarServidorPorIPPag(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.consultarServidorPorIPPag, reqServidor);
    }
    consultarServidorPorIPPagCOS(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.consultarServidorPorCOSIPPag, reqServidor);
    }
    consultarServidorPorIP(ipServidor: Servidor){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.consultarServidorPorIP, ipServidor);
    }
    ConsultaNumServidores(reqServdidor: Servidor){
        return this.httpClient.post<Base>(UrlConstantes.CONSULTA_NUM_SERVIDORES, reqServdidor);
    }
    ConsultaNumServidoresCOS(reqServdidor: Servidor){
        return this.httpClient.post<Base>(UrlConstantes.CONSULTA_NUM_SERVIDORESCOS, reqServdidor);
    }

    

    //AplicacionService
    ObtenerServidor(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.GET_SERVER, reqServidor);
    }

    ObtenerServidorPorIP(reqServidor: ConsultaList<Servidor>){
        return this.httpClient.post<ConsultaList<Servidor>>(UrlConstantes.GET_SERVER_BY_IP, reqServidor);
    }

    ObtenerAplicacionPorServidor(reqAplicacion: number){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.GET_APP_BY_SERVER, reqAplicacion);
    }

    ObtenerAplicacionPorTipo(reqAplicacion: ConsultaList<Aplicacion>){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.GET_APP_BY_TYPE, reqAplicacion);
    }

    ObtenerAplicacionPorTipoCOS(reqAplicacion: ConsultaList<Aplicacion>){
        return this.httpClient.post<ConsultaList<Aplicacion>>(UrlConstantes.GET_APP_BY_TYPE_COS, reqAplicacion);
    }

    EliminarApp(reqAplicacion: number){
        return this.httpClient.post<Base>(UrlConstantes.DELETE_APP, reqAplicacion);
    }

    EliminarUsuario(reqAplicacion: number){
        return this.httpClient.post<Aplicacion>(UrlConstantes.DELETE_USER, reqAplicacion);
    }
    
    GuaradarOActualizarApp(reqAplicacion: Aplicacion){
        return this.httpClient.post<Base>(UrlConstantes.SAVE_OR_UPDATE_APP, reqAplicacion);
    }

    GuaradarOActualizarUsuario(reqAplicacion: UsuarioFise){
        return this.httpClient.post<Base>(UrlConstantes.SAVE_OR_UPDATE_USER, reqAplicacion);
    }

    ObtenerUsuarioPorApp(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_APP, reqUsuarioBean);
    }
    ObtenerUsuarioPorSER(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_SER, reqUsuarioBean);
    }

    obtenerUsuarioPorAppPag(reqUsuarioBean:  ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_APP_PAG, reqUsuarioBean);
    }

    obtenerUsuarioPorAppPagCOS(reqUsuarioBean:  ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_APP_PAG_COS, reqUsuarioBean);
    }

    obtenerUsuarioPorSERPag(reqUsuarioBean:  ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_SER_PAG, reqUsuarioBean);
    }
    obtenerUsuarioPorSERPagCOS(reqUsuarioBean:  ConsultaList<UsuarioFise>){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_USER_BY_SER_PAG_COS, reqUsuarioBean);
    }

    contarUsuarioPorApp(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<Base>(UrlConstantes.COUNT_USER_BY_APP, reqUsuarioBean);
    }

    contarUsuarioDuplicadoPorApp(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<Base>(UrlConstantes.COUNT_USER_DUPLICATE_BY_APP, reqUsuarioBean);
    }
    
    contarUsuarioPorSER(reqUsuarioBean: UsuarioFise){
    return this.httpClient.post<Base>(UrlConstantes.COUNT_USER_BY_SER, reqUsuarioBean);
    }

    contarUsuarioPorSERCOS(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<Base>(UrlConstantes.COUNT_USER_BY_SER_COS, reqUsuarioBean);
        }

    contarUsuarioPorAPPCOS(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<Base>(UrlConstantes.COUNT_USER_BY_APPCOS, reqUsuarioBean);
        }
    //ConfigServidorUsuarioService

    ObtenerUsuarioPorPerfil(reqUsuarioBean:  ConsultaList<Usuario>){
        return this.httpClient.post<ConsultaList<Usuario>>(UrlConstantes.GET_USUARIO_PERFIL, reqUsuarioBean);
    }

    ObtenerUsuarios(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_US_SERVER, reqUsuarioBean);
    }

    ObtenerUsuariosCOS(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_US_SERVER_COS, reqUsuarioBean);
    }

    ObtenerUsuariosAPPCOS(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_US_SERVER_APP_COS, reqUsuarioBean);
    }

    GuaradarConfiguracionUsuarioPorServer(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConfiguracionBean>(UrlConstantes.SAVECONFIGURATIONUSERBYSERVER, reqServidor);
    }
    //********************************************************* */
    BorrarConfiguracionServer(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConfiguracionBean>(UrlConstantes.DELETE_CONFIG_US_SERVER, reqServidor);
    }

    BorrarConfiguracionServerApp(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConfiguracionBean>(UrlConstantes.DELETE_CONFIG_US_SERVER_APP, reqServidor);
    }
    BorrarConfiguracionApp(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConfiguracionBean>(UrlConstantes.DELETE_CONFIG_US_APP, reqServidor);
    }
     
    consultarConfiguracionServer(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_CONFIG_US_SERVER, reqServidor);
    }

    ObtenerConfiguracionUsuariosApp(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConsultaList<number>>(UrlConstantes.GET_CONFIG_US_APP, reqServidor);
    }


    ObtenerConfiguracionUsuariosSER(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConsultaList<number>>(UrlConstantes.GET_CONFIG_US_SER, reqServidor);
    }

    ObtenerConfiguracionUsuariosSERCOS(reqUsuarioBean: UsuarioFise){
        return this.httpClient.post<ConsultaList<UsuarioFise>>(UrlConstantes.GET_CONFIG_US_SER_COS, reqUsuarioBean);
    }

    GuaradarConfiguracionUsuarioPorAplicacion(reqServidor: ConfiguracionBean){
        return this.httpClient.post<ConfiguracionBean>(UrlConstantes.SAVECONFIGURATIONUSERBYAPPLICATION, reqServidor);
    }
}